import { FIELD_LIMITS } from '../../Constants/Stats'
import { StatFieldErrors, StatItem } from '../../Models'

const NUMBER_PATTERN = /^\d[\d,]*(\.\d+)?$/

export const NO_ERRORS: StatFieldErrors = Object.freeze({})

export function validateStat(item: StatItem): StatFieldErrors {
  const errors: StatFieldErrors = {}

  const number = item.number.trim()
  if (!number) {
    errors.number = 'Number is required.'
  } else if (!NUMBER_PATTERN.test(number)) {
    errors.number = 'Use digits only, e.g. 1.5 or 4,500.'
  } else if (number.length > FIELD_LIMITS.number) {
    errors.number = `Use at most ${FIELD_LIMITS.number} characters.`
  }

  if (item.prefix.trim().length > FIELD_LIMITS.prefix) {
    errors.prefix = `Use at most ${FIELD_LIMITS.prefix} characters.`
  }

  if (item.suffix.trim().length > FIELD_LIMITS.suffix) {
    errors.suffix = `Use at most ${FIELD_LIMITS.suffix} characters.`
  }

  const description = item.description.trim()
  if (!description) {
    errors.description = 'Description is required.'
  } else if (description.length > FIELD_LIMITS.description) {
    errors.description = `Use at most ${FIELD_LIMITS.description} characters.`
  }

  return errors
}

export function hasErrors(errors: StatFieldErrors): boolean {
  return Object.keys(errors).length > 0
}

export function isStatValid(item: StatItem): boolean {
  return !hasErrors(validateStat(item))
}
